<template>
  <div>
    <MembershipStoreBanner></MembershipStoreBanner>
    <MembershipStoreIntroduction></MembershipStoreIntroduction>
    <MembershipStoreNew></MembershipStoreNew>
    <MembershipStorePath></MembershipStorePath>
    <MembershipStoreBanner2></MembershipStoreBanner2>
    <MembershipStoreMarket></MembershipStoreMarket>
    <MembershipStoreBrand></MembershipStoreBrand>
    <MembershipStoreIntellectual></MembershipStoreIntellectual>
    <MembershipStoreSystem></MembershipStoreSystem>
    <MembershipStoreOperation></MembershipStoreOperation>
    <MembershipStoreConnect></MembershipStoreConnect>
  </div>
</template>

<script>
import MembershipStoreBanner from "@/yintai/view/content/membershipStore/MembershipStoreBanner.vue";
import MembershipStoreIntroduction from "@/yintai/view/content/membershipStore/MembershipStoreIntroduction.vue";
import MembershipStoreNew from "@/yintai/view/content/membershipStore/MembershipStoreNew.vue";
import MembershipStorePath from "@/yintai/view/content/membershipStore/MembershipStorePath.vue";
import MembershipStoreBanner2 from "@/yintai/view/content/membershipStore/MembershipStoreBanner2.vue";
import MembershipStoreMarket from "@/yintai/view/content/membershipStore/MembershipStoreMarket.vue";
import MembershipStoreBrand from "@/yintai/view/content/membershipStore/MembershipStoreBrand.vue";
import MembershipStoreIntellectual from "@/yintai/view/content/membershipStore/MembershipStoreIntellectual.vue";
import MembershipStoreSystem from "@/yintai/view/content/membershipStore/MembershipStoreSystem.vue";
import MembershipStoreOperation from "@/yintai/view/content/membershipStore/MembershipStoreOperation.vue";

import MembershipStoreConnect from "@/yintai/view/content/membershipStore/MembershipStoreConnect.vue";

export default {
  name: "memberShipStore",
  components: {
    MembershipStoreBanner,
    MembershipStoreIntroduction,
    MembershipStoreNew,
    MembershipStorePath,
    MembershipStoreMarket,
    MembershipStoreIntellectual,
    MembershipStoreSystem,
    MembershipStoreOperation,
    MembershipStoreConnect,
    MembershipStoreBanner2,
    MembershipStoreBrand,
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
